import Vue from 'vue';
import * as C from '../constants';
import defaultState from '../reminders/defaultState';

export default {
  [C.REMINDERS_RESET](state) {
    Object.assign(state, defaultState());
  },

  // <editor-fold desc="Domains">
  [C.REMINDERS_DOMAINS_PENDING](state) {
    state.domains = {
      ...state.domains,
      loading: true,
    };
  },

  [C.REMINDERS_DOMAINS_SUCCESS](state, domains) {
    state.domains = {
      loading: false,
      error: false,
      noContent: false,
      items: domains,
    };
  },

  [C.REMINDERS_DOMAINS_FAILURE](state) {
    state.domains = {
      loading: false,
      error: true,
      noContent: false,
      items: [],
    };
  },

  [C.REMINDERS_DOMAINS_NO_CONTENT](state) {
    state.domains = {
      loading: false,
      error: false,
      noContent: true,
      items: [],
    };
  },
  // </editor-fold>

  // <editor-fold desc="Templates">
  [C.REMINDERS_TEMPLATES_DOMAIN_SET](state, domain) {
    state.templates.domain = domain;
  },

  [C.REMINDERS_TEMPLATES_PENDING](state) {
    state.templates.templates = {
      ...state.templates.templates,
      noContent: false,
      loading: true,
      error: false,
    };
  },

  [C.REMINDERS_TEMPLATES_SUCCESS](state, templates) {
    state.templates.templates = {
      ...state.templates.templates,
      loading: false,
      items: templates,
    };
  },

  [C.REMINDERS_TEMPLATES_FAILURE](state) {
    state.templates.templates = {
      ...state.templates.templates,
      loading: false,
      error: true,
      items: [],
    };
  },

  [C.REMINDERS_TEMPLATES_NO_CONTENT](state) {
    state.templates.templates = {
      ...state.templates.templates,
      loading: false,
      noContent: true,
      items: [],
    };
  },

  [C.REMINDERS_TEMPLATE_SAVE_PENDING](state) {
    state.templates.save = {
      loading: true,
      error: false,
    };
  },

  [C.REMINDERS_TEMPLATE_SAVE_SUCCESS](state) {
    state.templates.save = {
      loading: false,
      error: false,
    };
  },

  [C.REMINDERS_TEMPLATE_SAVE_FAILURE](state) {
    state.templates.save = {
      loading: false,
      error: true,
    };
  },
  // </editor-fold>

  // <editor-fold desc="Rules">
  [C.REMINDERS_RULES_DOMAIN_SET](state, domain) {
    state.rules.domain = domain;
  },

  [C.REMINDERS_RULES_PENDING](state) {
    state.rules.rules = {
      item: {},
      noContent: false,
      loading: true,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SUCCESS](state, rule) {
    Vue.set(state.rules, 'rules', {
      ...state.rules.rules,
      loading: false,
      item: rule,
    });
  },

  [C.REMINDERS_RULES_FAILURE](state) {
    state.rules.rules = {
      ...state.rules.rules,
      loading: false,
      error: true,
      item: {},
    };
  },

  [C.REMINDERS_RULES_NO_CONTENT](state) {
    state.rules.rules = {
      ...state.rules.rules,
      loading: false,
      noContent: true,
      item: {
        templates: [],
        isLatest: true,
      },
    };
  },

  [C.REMINDERS_RULES_TEMPLATES_ADD](state, payload) {
    state.rules.rules.item.templates.push(payload);
  },

  [C.REMINDERS_RULES_TEMPLATES_DELETE](state, payload) {
    state.rules.rules.item.templates.splice(payload.index, 1);
    state.rules.rules.item.templates.forEach((template) => {
      if (template.order > payload.order) {
        template.order -= 1;
      }
    });
  },

  [C.REMINDERS_RULES_TEMPLATES_SWAP_ORDER](state, payload) {
    const templates = state.rules.rules.item.templates;
    const fromOrder = templates[payload.from].order;
    templates[payload.from].order = templates[payload.to].order;
    templates[payload.to].order = fromOrder;
  },

  [C.REMINDERS_RULES_TEMPLATES_PENDING](state) {
    state.rules.templates = {
      ...state.rules.templates,
      noContent: false,
      loading: true,
      error: false,
    };
  },

  [C.REMINDERS_RULES_TEMPLATES_SUCCESS](state, templates) {
    state.rules.templates = {
      ...state.rules.templates,
      loading: false,
      items: templates,
    };
  },

  [C.REMINDERS_RULES_TEMPLATES_FAILURE](state) {
    state.rules.templates = {
      ...state.rules.templates,
      loading: false,
      error: true,
      items: [],
    };
  },

  [C.REMINDERS_RULES_TEMPLATES_NO_CONTENT](state) {
    state.rules.templates = {
      ...state.rules.templates,
      loading: false,
      noContent: true,
      items: [],
    };
  },

  [C.REMINDERS_RULES_TEMPLATES_UPDATE](state, payload) {
    Vue.set(state.rules.rules.item.templates, payload.index, payload.template);
  },

  [C.REMINDERS_RULES_SAVE_PENDING](state) {
    state.rules.save = {
      loading: true,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SAVE_SUCCESS](state) {
    Vue.set(state.rules.rules, 'item', {});
    state.rules.save = {
      loading: false,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SAVE_FAILURE](state) {
    state.rules.save = {
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_RULES_REVISIONS_PENDING](state) {
    state.rules.revisions = {
      items: [],
      loading: true,
      noContent: false,
      error: false,
    };
  },

  [C.REMINDERS_RULES_REVISIONS_SUCCESS](state, payload) {
    state.rules.revisions = {
      ...state.rules.revisions,
      items: payload,
      loading: false,
    };
  },

  [C.REMINDERS_RULES_REVISIONS_FAILURE](state) {
    state.rules.revisions = {
      ...state.rules.revisions,
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_RULES_REVISIONS_NO_CONTENT](state) {
    state.rules.revisions = {
      ...state.rules.revisions,
      loading: false,
      noContent: true,
    };
  },

  [C.REMINDERS_RULES_REVISIONS_CURRENT](state, payload) {
    state.rules.currentRevision = payload;
  },

  [C.REMINDERS_RULES_SETTINGS_PENDING](state) {
    state.rules.settings.list = {
      items: [],
      loading: true,
      error: false,
      noContent: false,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_SUCCESS](state, payload) {
    state.rules.settings.list = {
      ...state.rules.settings.list,
      items: payload,
      loading: false,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_FAILURE](state) {
    state.rules.settings.list = {
      ...state.rules.settings.list,
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_NO_CONTENT](state) {
    state.rules.settings.list = {
      ...state.rules.settings.list,
      loading: false,
      noContent: true,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_ACTION_PENDING](state) {
    state.rules.settings.action = {
      loading: true,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_ACTION_SUCCESS](state) {
    state.rules.settings.action = {
      loading: false,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_ACTION_FAILURE](state) {
    state.rules.settings.action = {
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_DELETE_PENDING](state) {
    state.rules.settings.delete = {
      loading: true,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_DELETE_SUCCESS](state) {
    state.rules.settings.delete = {
      loading: false,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_DELETE_FAILURE](state) {
    state.rules.settings.delete = {
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_LOGS_PENDING](state) {
    state.rules.settings.logs = {
      items: [],
      loading: true,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_LOGS_SUCCESS](state, payload) {
    state.rules.settings.logs = {
      items: payload,
      loading: false,
      error: false,
    };
  },

  [C.REMINDERS_RULES_SETTINGS_LOGS_FAILURE](state) {
    state.rules.settings.logs = {
      items: [],
      loading: false,
      error: true,
    };
  },
  // </editor-fold>

  // <editor-fold desc="Lists">
  [C.REMINDERS_LISTS_PREVIEW_PENDING](state) {
    state.lists.preview = {
      loading: true,
      error: false,
      item: undefined,
    };
  },

  [C.REMINDERS_LISTS_PREVIEW_SUCCESS](state, payload) {
    state.lists.preview = {
      loading: false,
      item: payload,
    };
  },

  [C.REMINDERS_LISTS_PREVIEW_FAILURE](state) {
    state.lists.preview = {
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_LISTS_OVERVIEW_PENDING](state) {
    state.lists.overview = {
      loading: true,
      error: false,
      item: undefined,
    };
  },

  [C.REMINDERS_LISTS_OVERVIEW_SUCCESS](state, payload) {
    state.lists.overview = {
      loading: false,
      item: payload,
    };
  },

  [C.REMINDERS_LISTS_OVERVIEW_FAILURE](state) {
    state.lists.overview = {
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_LISTS_LIST_PENDING](state) {
    state.lists.list = {
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.REMINDERS_LISTS_LIST_SUCCESS](state, payload) {
    state.lists.list = {
      loading: false,
      items: payload,
    };
  },

  [C.REMINDERS_LISTS_LIST_FAILURE](state) {
    state.lists.list = {
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_LISTS_MESSAGES_PENDING](state, payload) {
    Vue.set(state.lists.messages, 'booking', payload);
    state.lists.messages.messages = {
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.REMINDERS_LISTS_MESSAGES_SUCCESS](state, payload) {
    state.lists.messages.messages = {
      loading: false,
      items: payload,
    };
  },

  [C.REMINDERS_LISTS_MESSAGES_FAILURE](state) {
    state.lists.messages.messages = {
      loading: false,
      error: true,
    };
  },

  [C.REMINDERS_LISTS_FILTERS_UPDATE](state, payload) {
    Vue.set(state.lists, 'filters', payload);
  },
  // </editor-fold>
};



// WEBPACK FOOTER //
// ./src/store/modules/reminders/mutations.js